module.exports = __webpack_public_path__ + "img/partner_logo1.5590fd35.png";